export default {"src":"/_next/static/media/undraw_booked_re_vtod.4fe4b2a2.svg","height":589,"width":767};